// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es6.object.assign.js
// module id = ./node_modules/babel-polyfill/node_modules/core-js/modules/es6.object.assign.js
// module chunks = 4